import { useEffect, useState } from 'react';

import { motion } from 'framer-motion';
import styled from 'styled-components';

import { RelativeSpinner } from '@components/loading-spinner';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';
import { second } from '@utils/milliseconds';

const MESSAGE_ROTATION_INTERVAL = 10 * second;

export type RotatingLoadingMessagesProps = {
  title: string;
  messages: string[];
};
export const RotatingLoadingMessages = ({ title, messages }: RotatingLoadingMessagesProps) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((idx) => (idx + 1) % messages.length);
    }, MESSAGE_ROTATION_INTERVAL);
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <>
      <Backdrop />
      <LoadingContainer>
        <Stack space={2} align="center" style={{ textAlign: 'center' }}>
          <Text text={title} font="bold14" color="indigo80" />
          <Text text={messages[current]} font="heading1" />
        </Stack>
        <RelativeSpinner />
      </LoadingContainer>
    </>
  );
};

const Backdrop = styled(motion.div)({
  position: 'fixed',
  backgroundColor: theme.color.purpleTrans40,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  overflow: 'hidden',
  zIndex: 999,
});

const LoadingContainer = styled(Stack)({
  gap: theme.space[6],
  alignItems: 'center',
  width: pxToRem(504),
  background: theme.color.backgroundPrimary,
  padding: `${pxToRem(48)} ${pxToRem(40)}`,
  position: 'fixed',
  top: ' 50%',
  left: ' 50%',
  transform: 'translate(-50%, -50%)',
  border: `1px solid ${theme.color.border10}`,
  borderRadius: pxToRem(24),
  boxShadow: theme.shadow.fancy,
  zIndex: 1000,
});
